import React from "react";
import {
    Select,
    Row,
    Col,
    Button,
    Space,
    DatePicker,
    Dropdown,
    Modal, Checkbox, Tooltip, Image
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import { DownOutlined, StarFilled, StarOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import MonthlyDistanceReportStore from "../store/MonthlyDistanceReportStore";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import VehicleStore from "../store/VehicleStore";

const { RangePicker } = DatePicker;

const { Option } = Select;

let widthAdderFunc = (arr) => {
    let array = arr;
    array.map((val) => {
        if (val.title?.length > 24) {
            val.width = 250;
        } else if (val.title?.length > 15) {
            val.width = 200;
        } else if (val.title?.length > 12) {
            val.width = 150;
        } else if (val.title?.length > 8) {
            val.width = 125;
        } else {
            val.width = 110;
        }
    });

    return arr;
};

class MonthlyDistanceReport extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        // this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.vehicleStore = new VehicleStore();

        this.MonthlyDistanceReportStore = new MonthlyDistanceReportStore(this);
        this.ExportOption = [
            {
                label: (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                        }}
                    >
                        {" "}
                        <Image
                            style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                            src={Excel}
                        ></Image>
                        {context.translate("_EXPORT_AS_EXCEL_")}
                    </div>
                ),
                key: "excel",
            },
        ];
        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            selectedVehicles: [],
            selectAllVehicles: false,
            selectAllDrivers: false,
            showMonthPopup: false,
            filterby: "",
            data: "",
            companyId: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            Notcompany: false,
            Notasset: false,
            NotDriver: false,
            selectedColumns: widthAdderFunc([
                {
                    title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    width: "15%",
                },
                {
                    // title: "Month",
                    title: context.translate("_MONTH_"),
                    dataIndex: "month",
                    width: "15%",
                    key: "month",
                },
                {
                    title: context.translate("_MONTHLY_DISTANCE_LIMIT_"),
                    dataIndex: "monthlyDistanceLimit",
                    width: "15%",
                    key: "monthlyDistanceLimit",
                }, {
                    title: context.translate("_DISTANCE_TRAVEL_"),
                    dataIndex: "distanceTravel",
                    width: "15%",
                    key: "distanceTravel",
                },
                {
                    title: context.translate("_EXCEEDED_DISTANCE_"),
                    dataIndex: "exceededDistance",
                    width: "15%",
                    key: "exceededDistance",
                },
            ]),
        };
        this.menuProps = {
            items: this.ExportOption,
            onClick: (val) => {
                let result = [];

                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    var getData = {
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        companyId: this.state.companyId,
                        vehicleId: this.state.selectedVehicles,
                        filterBy: this.state.filterby,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        colList: result.toString(),
                        language: null,
                    };
                    if (val.key == "excel") {
                        this.MonthlyDistanceReportStore.exportExcel(getData);
                    }
                    if (val.key == "pdf") {
                        this.MonthlyDistanceReportStore.exportpdf(getData);
                    }
                }
            },
        };
        this.newColumns = [...this.state.selectedColumns];
    }

    async componentDidMount() {
        this.setState({ pageSize: 50 });

        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }
        await this.setState({ column: this.state.selectedColumns });
    }

    handleAllSelectVehicles = async () => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ companyId: comp?.value });
        await this.setState({
            selectedVehicles: [],
            selectAllVehicles: false,
        });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);
        await this.setState({ loadData: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }

    addMonths = (date, months) => {
        var indx = dayjs().month() + -6;

        return dayjs().month(indx);
    };
    checkFromDate(dates) {
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }

    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        }
    };

    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }

        if (this.state.selectedVehicles.length === 0) {
            this.setState({ Notasset: true });
        } else {
            this.setState({ Notasset: false });
        }
        if (this.state.companyId && this.state.selectedVehicles.length > 0) {
            this.setState({ Notcompany: false, Notasset: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.KeyNotTaggedReportStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    vehicleId: this.state.selectedVehicles,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                });
                await this.setState({ loadData: 1 });
            }
        }
    };
    refreshList = async () => {
        await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
        await this.showData();
    };
    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
        }
    };
    render() {
        return (
            <>

                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />

                                {this.props.getUserData().isadmin === 1 && (
                                    <DeviceGroupsForVehicles
                                        vehicleStore={this.vehicleStore}
                                        setLoadDta={() => this.setState({ loadData: 1 })}
                                        resetVehicles={() =>
                                            this.setState({
                                                selectedVehicles: [],
                                                selectAllVehicles: false,
                                            })
                                        }
                                    />
                                )}
                                <Checkbox
                                    checked={this.state.selectAllVehicles}
                                    onChange={async (e) => {
                                        await this.setState({
                                            selectAllVehicles: e.target.checked,
                                        });
                                        await this.handleAllSelectVehicles();
                                    }}
                                />
                                {this.context.translate("_ALL_")}

                                <Select
                                    className="searchInput"
                                    maxTagCount="responsive"
                                    value={this.state.selectedVehicles}
                                    onChange={(val) => {
                                        this.setState({ selectedVehicles: val });
                                        if (
                                            this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                                            val.length
                                        ) {
                                            this.setState({ selectAllVehicles: false });
                                        } else {
                                            this.setState({ selectAllVehicles: true });
                                        }
                                    }}
                                    style={{ width: 150 }}
                                    showSearch
                                    status={this.state.Notasset ? "error" : false}
                                    mode="multiple"
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                        return (
                                            <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                                        );
                                    })}
                                </Select>

                                <RangePicker
                                    className="searchInput"
                                    placeholder={[
                                        this.context.translate("_FROM_DATE_TIME_"),
                                        this.context.translate("_TO_DATETIME_"),
                                    ]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    // disabledDate={(current) => {
                                    //   return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [dayjs().startOf("day"), dayjs()],
                                    }}
                                    defaultValue={[dayjs().startOf("day"), dayjs()]}
                                />

                                <Button type="primary" onClick={() => this.showData()}>
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>

                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>
                        <Col span={4}>
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            ></Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.MonthlyDistanceReportStore?.customerFeedbackData?.length > 0
                                            ? false
                                            : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.menuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.MonthlyDistanceReportStore?.total}
                        columns={this.state.column}
                        dataSource={this.MonthlyDistanceReportStore?.customerFeedbackData}
                        loading={this.MonthlyDistanceReportStore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>
                <Modal
                    open={this.state.modalVisible}
                    width={250}
                    // title="Select Columns"
                    title={this.context.translate("_SELECT_COLUMNS_")}
                    onCancel={() => this.setState({ modalVisible: false })}
                    onOk={() => {
                        this.setState({ modalVisible: false });
                    }}
                    footer={null}
                >
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {console.log(this.newColumns, "Df")}
                        {this.newColumns.map((column, v) => {
                            return (
                                <Row key={v}>
                                    <Col>
                                        <Checkbox
                                            onChange={() => this.handleCheckboxChange(column)}
                                            checked={this.state.selectedColumns.some(
                                                (c) => c.key === column.key
                                            )}
                                        >
                                            {column.title}
                                        </Checkbox>
                                    </Col>
                                </Row>
                            );
                        })}
                    </div>
                </Modal>
                <Modal
                    width={350}
                    className="alert-model"
                    title={
                        <div>
                            {" "}
                            <i
                                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                class="bi bi-exclamation-triangle"
                            ></i>{" "}
                            {this.context.translate("_FLEET_ALERT_")}
                        </div>
                    }
                    open={this.state.showMonthPopup}
                    onOk={() => this.setState({ showMonthPopup: false })}
                    onCancel={() => this.setState({ showMonthPopup: false })}
                    footer={false}
                >
                    {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                </Modal>
            </>
        );
    }
}
MonthlyDistanceReport.contextType = StoreContext;
export default observer(withRouter(MonthlyDistanceReport));
